import { useEffect } from 'react';

export interface UseUnsavedChangesWarningOptions {
  when: boolean;
  // Title / body / confirm / cancel labels are accepted but unused: an in-app
  // navigation guard needs `useBlocker`, which requires a v7 data router. Only
  // the `when` flag drives a beforeunload listener, which catches tab close,
  // refresh, and external navigation.
  title?: string;
  body?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export function useUnsavedChangesWarning({ when }: UseUnsavedChangesWarningOptions) {
  useEffect(() => {
    if (!when) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [when]);
}
